import { useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import isEqual from 'lodash/isEqual';
import { slice as historySlice } from 'state/journey-routes/journey-routes-slice';

import { initialState } from 'state/allSlices';

export const useInitialState = () => {
  const currentState = useSelector((state) => state, shallowEqual);

  const excludeSlices = (excludeSlices) => {
    const currentStateCopy = { ...currentState };
    const initialStateCopy = { ...initialState };

    excludeSlices.forEach((sliceName) => {
      delete currentStateCopy[sliceName];
      delete initialStateCopy[sliceName];
    });

    return [currentStateCopy, initialStateCopy];
  };

  const hasStateInitialValue = isEqual(
    ...excludeSlices([
      // delete history slice before compare as this always contains initial landing path
      historySlice.name
    ])
  );

  return useMemo(() => ({ hasStateInitialValue }), [hasStateInitialValue]);
};
